const r = {
  primary: {
    color: "fg-white",
    backgroundColor: "button-primary-bg",
    borderColor: "button-primary-bg"
  },
  secondary: {
    color: "fg-primary",
    backgroundColor: "button-glassy-light-bg",
    borderColor: "button-glassy-border",
    boxShadow: "shadow-3",
    backdropFilter: "blur(12px)"
  },
  tertiary: {
    color: "fg-primary",
    backgroundColor: "button-glassy-dark-bg",
    borderColor: "transparent",
    boxShadow: "shadow-3",
    backdropFilter: "blur(12px)"
  },
  quaternary: {
    background: "transparent",
    borderColor: "transparent",
    color: "text-primary"
  }
};
export {
  r as variant
};
